import type { Media } from './media'
import { Cascadify } from './util'

export enum ActivityStepMediaType {
  Mission = 'mission',
  Host = 'host',
  Sfx = 'sfx',
}

export type StepMediaSettings = {
  /** Integer value in 1-100 range  */
  volume?: number
  loop?: boolean
  overlay?: boolean
}
export type ActivityStepMediaId = string
export type RootActivityStepMedia = {
  id: ActivityStepMediaId
  mediaId: number
  type: ActivityStepMediaType
  settings: StepMediaSettings
}

export type ActivityStepMedia = RootActivityStepMedia & {
  stepId: number
  media: Media
}

export type CascadeActivityStepMedia = Cascadify<RootActivityStepMedia> & {
  stepId?: number
  media: Media
}
